<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="feedForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :is-not-server-handled="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="feed" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                feedForm: () => import('../forms/FeedForm'),
                feed: () => import('../editViews/Feed'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'Is Supplementary Nutrition Feed', value: 'isSupplementaryNutritionFeed' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                ],
                itemsField: 'feeds',
                editPageName: 'feed',
                apiMethod: 'Feeds',
                claimName: 'Feeds',
                formTitle: 'Feed',
                excelTitle: 'Feeds',
                hasEditPage: true,
            }
        },
    };
</script>
